import * as React from 'react';
import Icon from 'antd/lib/icon';
import './IconSearch.scss';

const IconSearch  = () => <div className="IconSearch">
	<Icon type="search" />
</div>

export default IconSearch;
